export default [
  {
    name: 'Bluza HUSARIA',
    price: 75,
    image: require('./assets/husaria.png'),
    description:
      'Oficjalna bluza upamiętniająca najpotężniejszą jazdę w Europie.',
  },
  {
    name: 'Bluza POLWEAR',
    price: 75,
    image: require('./assets/polwear.png'),
    description: 'Oficjalna bluza z naszym logo',
  },
  {
    name: 'Bluza GRUNWALD',
    price: 75,
    image: require('./assets/grunwald.png'),
    description:
      'Oficjalna bluza upamiętniająca jedno z najwspanialszych zwycięstw Polski.',
  },
  {
    name: 'Obudowa na telefon HUSARIA',
    price: 50,
    image: require('./assets/obudowa.png'),
    description: 'Gumowa budowa z naszym logo.',
  },
];
